var routeinfo = {
  name: "",
  icon: ""
};

export default function(state = routeinfo, action) {
  switch (action.type) {
    case "Current Route":
      console.log("route = " + action.payload);
      return {
        ...state,
        name: action.payload,
        icon: action.icon
      };
      break;
  }

  return state;
}



// WEBPACK FOOTER //
// ./src/reducers/route-reducer.js